import { NoteDto } from 'src/@types/note';
import { apiClient } from 'src/careflow/ph-core/api_client/api_client';

export async function getGenericNotes(recordId: string) {
  if (!recordId) {
    throw new Error('recordId is required to fetch notes');
  }
  const data= await apiClient.get(`/notes/${recordId}`);

  return data;
}

export async function createNote(payload: NoteDto) {
  const data= await apiClient.post(`/notes`, payload);

  return data;
}

export async function updateGenericNote(payload: NoteDto, entityId?: string) {
  const data= await apiClient.patch(`/notes/${entityId}`, payload);

  return data;
}
